module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Buus-720e2df3ac9426b322e69cef8fa64b5b.svg";